import initialState from './initialState';

export default (state = initialState) => state;
